// extracted by mini-css-extract-plugin
export default {"keyword":"Keyword_keyword__w6GjL"};